import slideStyle from "./InfoPage.module.scss";
import ContactAppendix from "./ContactAppendix";
import Heading from "./Heading";
import { getMessage, MessageContext, Message } from "@messageformat/react";
import { useContext } from "react";

const KioskAI = () => {
  const messageContext = useContext(MessageContext);

  return (
    <>
      <Heading
        subtitle={<Message id="infoPages.posApp.subtitle" />}
        title={<Message id="infoPages.posApp.title" />}
        hints={[
          <Message id="infoPages.posApp.hints.hint1" />,
          <Message id="infoPages.posApp.hints.hint2" />,
          <Message id="infoPages.posApp.hints.hint3" />,
        ]}
      />
      <div className={slideStyle.section}>
        <div className={slideStyle.sectionContent}>
          <div>
            <h2 className={slideStyle.centered}>
              <Message id="infoPages.posApp.descriptionTitle" />
            </h2>
            <div className={slideStyle.embeddedImg}>
              <img src={require("../assets/pos-paper.jpg")} alt="POS" />
            </div>
            <div
              dangerouslySetInnerHTML={{
                __html: getMessage(
                  messageContext,
                  "infoPages.posApp.description"
                )(),
              }}
            />
          </div>

          <div
            className={slideStyle.heading}
            style={{ marginTop: "20px", marginBottom: "20px" }}
          >
            <h1>
              <Message id="infoPages.posApp.summary" />
            </h1>
          </div>
        </div>

        <ContactAppendix />
      </div>
    </>
  );
};

export default KioskAI;
